// This file is automatically generated. Do not edit it directly.
import { createClient, processLock } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    // Serialise token refreshes inside this tab only, not across every window.
    //
    // The default is navigatorLock, which takes a Web Lock named after the storage key.
    // That lock is shared by every tab and window on this origin, and supabase-js takes
    // it on EVERY authenticated request, not just refreshes — so one window that stops
    // pumping its event loop (an installed PWA left in the background, a frozen or
    // crashed tab) holds it and every other window hangs for ever with a blank screen.
    // Reproduced: with the lock held, the app rendered nothing at all after 30s.
    //
    // processLock keeps the same serialisation within a tab, which is what actually
    // prevents concurrent refreshes racing, and lets each window make progress alone.
    lock: processLock,
  }
});